export default "__VITE_ASSET__Duot5yNL__"